module.exports = __webpack_public_path__ + "img/logoTest.407403ab.png";